module.exports = __webpack_public_path__ + "5cd31b8bcce6af9f6f8f618d395411d4.ttf";